import { browser } from '$app/environment';
import { sendAnalyticsEvent } from '$lib/services/analytics';
import { closeCookieModal } from '$lib/store';
import { EventNames, EventSectionName } from '$lib/types/analytics';
import { PREFERENCE_COOKIE } from '$lib/types/cookies';

/**
 * Cookie Dismiss Types
 * @enum {string}
 */

export enum CookieDismiss {
  QUICK_LINK = 'quick_link',
  HERO_WIDGET = 'hero_widget',
  MENU = 'menu',
  TOP_NAV = 'top_nav',
  POPUP_CTA = 'popup_cta',
  SCROLL = 'scroll'
}

/**
 * Retries Cookies from the browser
 * @param name cookie key
 * @returns cookie value
 */
const COOKIE_PREFERENCE = 'cookie-preference';
const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
const expiry = new Date(Date.now() + ONE_YEAR_MS).toUTCString();

export const getCookie = (name: string) => {
  const result = document.cookie.match('(^|[^;]+)s*' + name + 's*=s*([^;]+)');
  return result ? result.pop() : '';
};

export const setCookie = (key: string, value: string) => {
  document.cookie = `${key}=${value}; expires=${expiry}; path=/`;
};

/**
 *
 * @param cookieHeader
 * @returns cookies object
 */
export const parseCookies = (cookieHeader: string) => {
  const cookies = Object.fromEntries(
    cookieHeader.split(';').map((cookie) => {
      const [name, ...value] = cookie.trim().split('=');
      return [name, decodeURIComponent(value.join('='))];
    })
  );
  return cookies;
};

/**
 * Sets Cookie Preferences
 * @param enableCookies enable cookies or not
 * @param sectionName section name
 * @param eventName event name
 * @param type type of event
 */

export const setCookiePreferences = (
  enableCookies: string,
  sectionName: EventSectionName,
  eventName: EventNames,
  type: CookieDismiss
) => {
  sendAnalyticsEvent(eventName, {
    section_name: sectionName,
    description: `Cookie ${enableCookies}`,
    type
  });
  setCookie(COOKIE_PREFERENCE, enableCookies);
  closeCookieModal.set(true);
};

/**
 * Dismisses the cookie banner
 * @param dismissType dismiss type
 * @returns void
 */

export const dismissCookieBanner = (dismissType: CookieDismiss) => {
  if (browser) {
    getCookie('cookie-preference') !== PREFERENCE_COOKIE.ACCEPTED &&
      setCookiePreferences(
        PREFERENCE_COOKIE.ACCEPTED,
        EventSectionName.COOKIE_MODAL,
        EventNames.CONSENT_RECORDED,
        dismissType
      );
  }
};
